import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import api from "../../services/api";
import UpgradeModal from "./UpgradeModal";
import HamburgerButton from "./HamburgerButton";
import "./Sidebar.css";
import UpgradeButton from "../UpgradeButton";

const Sidebar = () => {
  const { user } = useContext(AuthContext);
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const NavLinkWithClose = ({ to, children }) => (
  <Link to={to} onClick={() => setSidebarOpen(false)}>
    {children}
  </Link>
);

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await api.get("topics/");
        // 確保 response.data 是陣列
        const topicsData = Array.isArray(response.data) ? response.data : [];
        setTopics(topicsData.slice(0, 5));
      } catch (err) {
        console.error("Failed to fetch topics:", err);
        setError("無法加載熱門主題");
        // 錯誤時設為空陣列
        setTopics([]);
      } finally {
        setLoading(false);
      }
    };
    fetchTopics();
  }, []);

  // Body scroll lock for mobile UX
  useEffect(() => {
    document.body.classList.toggle("sidebar-open", sidebarOpen);
  }, [sidebarOpen]);

  return (
    <>
      <HamburgerButton onClick={() => setSidebarOpen(!sidebarOpen)} />

      {sidebarOpen && (
        <div className="sidebar-backdrop active" onClick={() => setSidebarOpen(false)} />
      )}

      <aside className={sidebarOpen ? "open" : ""}>
        <ul>
          <li className="hover-effect"><NavLinkWithClose to="/">首頁</NavLinkWithClose></li>
          <li className="hover-effect"><NavLinkWithClose to="/dashboard">發文</NavLinkWithClose></li>
          {user && (
            <li className="hover-effect"><NavLinkWithClose to={`/user/${user.username}`}>個人主頁</NavLinkWithClose></li>
          )}
          <li>
            <UpgradeButton onClick={() => setShowUpgradeModal(true)} />
          </li>
          <li className="sidebar-section-title">熱門主題</li>
          {loading && <li>載入中...</li>}
          {error && <li className="error">{error}</li>}
          {!loading && !error && topics.map((topic) => (
            <li key={topic.id} className="hover-effect">
              <NavLinkWithClose to={`/topics/${topic.id}`}>{topic.name}</NavLinkWithClose>
            </li>
          ))}
        </ul>
      </aside>

      {showUpgradeModal && (
        <UpgradeModal onClose={() => setShowUpgradeModal(false)} />
      )}
    </>
  );
};

export default Sidebar;